/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useLenis } from "../components/SmoothScroll";
import HomeBannerSwiper from "../components/Home/HomeBannerSwiper";
import HomeSec2 from "../components/Home/HomeSec2";
import { Helmet } from "react-helmet-async";
const HomePage = () => {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  return (
    <>
      <Helmet>
        <title>Diagnostic Imaging Center | MRI, CT and Radiology Services
</title>
        <meta
          name="description"
          content="What defines a high-quality imaging center? Radiologist-owned expertise, advanced MRI technology and precise diagnostic reporting for confident decisions."
        />
        <meta
          name="keywords"
          content="best diagnostic center
imaging services
diagnostic imaging
medical imaging
mri imaging
diagnostic imaging center
community radiology
radiology imaging
diagnostic radiology

"
        />
      </Helmet>
      <HomeBannerSwiper />
      <HomeSec2 />
    </>
  );
};

export default HomePage;
